import { useMemo } from "react";

import { useFilterContext } from "../FilterContext";
import { FilterFieldKey } from "../typing";

const useFilterCondition = (): Partial<Record<FilterFieldKey, boolean>> => {
  const { filterOptions } = useFilterContext();
  return useMemo(() => {
    return {
      category: false,
      extraCategory: filterOptions.categoryOptions.length > 0,
    };
  }, [filterOptions]);
};

export default useFilterCondition;
